import { combineReducers, createStore } from 'redux';

import user from './user';
import projects from './projects';
import headers from './headers';

const appReducers = combineReducers({
  user,
  projects,
  headers,
});

export const store = createStore(appReducers);

export default appReducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js